<template>
	<div>

		<layout-1
			:table_name="'Timesheets'"
			:id=pageid
			:searchbar=true
			:navbar=false
			:term=term
			:reroute="'/0326'"
			style="width:100%; height:calc(100vh);"
		></layout-1>

	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.TIMESHEETS_B_PAGE,
		}
	},
	methods:{

	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Timesheets.vue